<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="page-content">
                <div class="page-content-left">
                    <div class="page-content-left-title">联系我们</div>
                    <div class="page-content-left-content" v-html="contactObj.content"></div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'contactObj'
    ]),
    components:{
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'联系我们', href:'/aboutISOC'},
            ],
        }
    },
    mounted(){
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.page-content{
    width: 1120px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 30px 0 60px 0;
}
.page-content-left{
    width: 100%;
}
.page-content-left-title{
    font-size: 28px;
    font-weight: 700;
    color: #333333;
    line-height: 40px;
    margin-bottom: 20px;
}
.page-content-left-content{
    color: #666666;
    line-height: 28px;
}
.page-content-left-content :deep(img){
    max-width: 100%;
    height: auto;
}
.news{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .single{
        width: 580px;
    }
}
</style>
